import gql from 'graphql-tag';

export default gql`
    mutation AuthRegisterViaApple($token: String!) {
        auth {
            registerViaApple(token: $token) {
                ... on OauthToken {
                    token
                }
                ... on OauthException {
                    code
                }
            }
        }
    }
`;
